import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import VirbalSignup from './components/VirbalSignup-Green';
import CompleteSignup from './components/CompleteSignup';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import SignupSuccess from './components/SignupSuccess';

// Wrapper to extract token from URL path
function JoinRedirect() {
  const { token } = useParams();
  return <CompleteSignup token={token} />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/signup" />} />
        <Route path="/signup" element={<VirbalSignup />} />
        <Route path="/join/:token" element={<JoinRedirect />} />
        <Route path="/complete-signup" element={<CompleteSignup />} />
        <Route path="/signup-success" element={<SignupSuccess />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
